import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IContact } from '../../../models/contact.interface';
import { EInvoiceSignUpService } from '../services/e-invoice-sign-up.service';
import { Observable } from 'rxjs';
import { IEInvoiceSubscription } from '../models/e-invoice-subscription.interface';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../services/notification/notification.service';
import { NotificationType } from '../../../models/notification-type';
import { TranslateService } from '@ngx-translate/core';
import { UtilityService } from '../../../services/utility/utility.service';
import { ErrorHandlerService } from '../../../services/error-handler/error-handler.service';

@Component({
  selector: 'upsc-e-invoice-sign-up-dialog',
  templateUrl: './e-invoice-sign-up-dialog.component.html',
  styleUrls: ['./e-invoice-sign-up-dialog.component.scss'],
})
export class EInvoiceSignUpDialogComponent implements OnInit, OnDestroy {
  public contactStream: Observable<IContact>;
  public isInProgress = true;

  private optingSubscription: Subscription;

  constructor(private eInvoiceSignUpService: EInvoiceSignUpService,
              private notificationService: NotificationService,
              private utilityService: UtilityService,
              private errorHandlerService: ErrorHandlerService,
              private translateService: TranslateService,
              public dialogRef: MatDialogRef<EInvoiceSignUpDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.contactStream = this.eInvoiceSignUpService.getContactCorporate();
  }

  public ngOnInit() {
  }

  public ngOnDestroy() {
    if (this.optingSubscription) {
      this.optingSubscription.unsubscribe();
      this.optingSubscription = null;
    }
  }

  public onContactRendered(contact: IContact) {
    this.isInProgress = !contact;
  }

  public onFormSubmitting(subscription: IEInvoiceSubscription) {
    this.isInProgress = true;

    if (this.optingSubscription) {
      this.optingSubscription.unsubscribe();
      this.optingSubscription = null;
    }

    this.optingSubscription = this.eInvoiceSignUpService.updateEInvoiceSubscription(subscription)
      .subscribe(
        result => this.handleUpdateEInvoiceSubscriptionSuccess(result, subscription),
        err => this.handleUpdateEInvoiceSubscriptionFailure(err),
      );
  }

  private handleUpdateEInvoiceSubscriptionSuccess(result, subscription: IEInvoiceSubscription) {
    this.utilityService.delay(() => {
      this.isInProgress = false;
    });

    this.translateService.get('eInvoiceSignUp.Dialog.Success')
      .subscribe(
        (value) => {
          this.notificationService.notify(
            value.Message,
            value.Title,
            NotificationType.SUCCESS);
        },
      );

    this.dialogRef.close(subscription);
  }

  private handleUpdateEInvoiceSubscriptionFailure(err) {
    this.utilityService.delay(() => {
      this.isInProgress = false;
    });

    const errorTitleKey = 'eInvoiceSignUp.Dialog.Failure.Title';
    const errorMessageKey = 'eInvoiceSignUp.Dialog.Failure.Message';

    this.translateService.get(
      [
        errorTitleKey,
        errorMessageKey,
      ],
      { errorMessage: this.errorHandlerService.getHttpErrorMessage(err) })
      .subscribe(
        (value) => {
          this.notificationService.notify(
            value[errorTitleKey],
            value[errorMessageKey],
            NotificationType.ERROR);
        },
      );
  }
}
